<template>
  <div id="app">
    <app-header />
    <router-view></router-view>
    <!-- Footer -->
<footer class="page-footer font-small blue">

  <!-- Copyright -->
  <div class="footer-copyright text-center py-3">© 2024 Copyright:
    <a > Legiox</a>
  </div>
  <!-- Copyright -->

</footer>
<!-- Footer -->
  </div>
</template>

<script>
  import Header from './components/header/header.vue'
  // import Carrousel from './components/navigate/carrousel.vue'
  export default {
    name: 'app',
    components: {
      'app-header': Header,
      // 'app-carrousel': Carrousel
    },
    created () {

      // this.$store.dispatch('tryAutoLogin')
    }
  }
</script>

<style>
  body, html {
    margin: 0;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    height: 100%;
  }
  #app{
    /* height: 100%; */
  }
</style>


// WEBPACK FOOTER //
// src/App.vue